import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import PricingCard from '../components/PricingCard';
import useSubscriptionProducts from '../hooks/useSubscriptionProducts';

const SubscriptionRequiredPage = ({ isCreatingCheckout, onStartTrial, onLogout }) => {
  const { plans, loadingPlans, error: plansError } = useSubscriptionProducts();

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
        Subscription Required
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
        To start managing your inventory and accessing all features, choose a plan below.
      </Typography>

      {plansError && (
        <Alert severity="error" sx={{ mb: 3, maxWidth: 800, mx: 'auto' }}>
          {plansError}
        </Alert>
      )}

      {loadingPlans ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', mb: 3 }}>
          {plans.map((plan, idx) => (
            <PricingCard
              key={idx}
              plan={plan}
              onSelect={onStartTrial}
              disabled={isCreatingCheckout}
              disabledText="Starting Trial..."
              minWidth="280px"
              maxWidth="360px"
            />
          ))}
        </Box>
      )}

      <Button
        variant="outlined"
        onClick={onLogout}
        sx={{ textTransform: 'none', fontSize: '1rem', maxWidth: 300 }}
      >
        Logout
      </Button>
    </Box>
  );
};

export default SubscriptionRequiredPage;
